import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoCreditcard24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M16.8438 4.95837C18.4316 4.95837 19.7187 6.24557 19.7188 7.83337V15.8021C19.7188 17.39 18.4316 18.6771 16.8438 18.6771H7C5.41219 18.6771 4.125 17.39 4.125 15.8021V7.83337C4.125 6.24556 5.41218 4.95837 7 4.95837H16.8438ZM6.125 15.8021C6.125 16.2854 6.51674 16.6771 7 16.6771H16.8438C17.327 16.6771 17.7188 16.2854 17.7188 15.8021V10.9271H6.125V15.8021ZM10.2812 13.1771C10.6955 13.1771 11.0312 13.5129 11.0312 13.9271C11.0312 14.3413 10.6955 14.6771 10.2812 14.6771H7.9375C7.52329 14.6771 7.1875 14.3413 7.1875 13.9271C7.1875 13.5129 7.52329 13.1771 7.9375 13.1771H10.2812ZM15.9062 13.1771C16.3205 13.1771 16.6562 13.5129 16.6562 13.9271C16.6562 14.3413 16.3205 14.6771 15.9062 14.6771H15.4375C15.0233 14.6771 14.6875 14.3413 14.6875 13.9271C14.6875 13.5129 15.0233 13.1771 15.4375 13.1771H15.9062ZM7 6.95837C6.51675 6.95837 6.125 7.35012 6.125 7.83337V9.42712H17.7188V7.83337C17.7187 7.35012 17.327 6.95837 16.8438 6.95837H7Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoCreditcard24;